import React from 'react';
import { Tooltip } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class MyChartNotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showToolTip: false
        };
        this.toggleTooltip = this.toggleTooltip.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.Proxy.MyChartNotFound.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    linkAccount = () => {
        logUI("MBHWeb.Proxy.MyChartNotFound.LinkAccount", new Date(), Tools.getURLPath());
        this.props.history.push({
            pathname: '/linkedaccounts',
            searchParams: "openMyChart=true"
        });
    }

    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    render() {
        const { createAccountLink, technicalHelpDeskNumber, technicalHelpDeskHours } = this.props;
        const { showToolTip } = this.state;
        return (<div className="container-fluid body-content no-mychart-container">
            <div className="row">
                <div className="col-12">
                    <h1 className="step-heading">Please link your medical record to approve this request.</h1>
                </div>
                <div className="col-12 button-list">
                    <div className="form-group">
                        <span>To link, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.</span>                
                    </div>                
                    <div className="form-group">
                        <a href={createAccountLink} target='_blank' className='btn btn-primary'>LINK WITH YOUR ACTIVATION CODE <span className="icon-question" id="btn-lnk" /></a>
                    </div>
                    <Tooltip placement="top" isOpen={showToolTip} autohide={false} target="btn-lnk" toggle={this.toggleTooltip}>
                        This may be an option if you received an activation code from your visit with us.
                    </Tooltip>
                </div>
            </div>
        </div>);
    }

}
export default MyChartNotFound;